import PropTypes from 'prop-types';

const NoProfileData = ({ body, children, className, heading }) => (
  <div className={`no-profile-data ${className}`}>
    <h2>{heading}</h2>
    <p>{body}</p>
    {children}
  </div>
);

NoProfileData.propTypes = {
  body: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
};

NoProfileData.defaultProps = {};

export default NoProfileData;
